import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';

import { EMAIL_VALIDATOR } from '../../../../models';
import {
  AgreementsComponent,
  AttentionBoxComponent,
  GithubButtonComponent,
  LinkedinButtonComponent,
  FacebookButtonComponent,
  GoogleButtonComponent,
} from '../../../common';

@Component({
  selector: 'jrui-signup-landing-page',
  templateUrl: './signup.landing.component.html',
  styleUrls: ['./signup.landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatInputModule,
    MatToolbarModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    AgreementsComponent,
    AttentionBoxComponent,
    LinkedinButtonComponent,
    GithubButtonComponent,
    FacebookButtonComponent,
    GoogleButtonComponent,
  ],
})
export class SignupLandingComponent implements OnInit {
  @Input() email = '';
  @Input() githubUrl = '';
  @Input() linkedInUrl = '';
  @Input() facebookUrl = '';
  @Input() googleUrl = '';
  @Output() signup = new EventEmitter();

  signupForm!: FormGroup;

  ngOnInit(): void {
    this.signupForm = new FormGroup({
      email: new FormControl(this.email, [
        Validators.required,
        Validators.pattern(EMAIL_VALIDATOR),
      ]),
    });
  }

  onSignup() {
    if (this.signupForm.valid && this.signupForm.controls['email'].value) {
      const email = this.signupForm.controls['email'].value.toLowerCase();
      this.signup.emit(email);
    }
  }
}
